import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Theme } from '../service/AutoTheme';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationService } from '../../authentication/authentication.service';
import { SipJsService } from '../service/sipjsServices.class';
import { ServerSocket } from '../service/Activity.socket';
import { Router } from '@angular/router';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DialpadComponent } from '../../dialer/dialpad/dialpad.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DialpersonalComponent } from '../../dialer/dialpersonal/dialpersonal.component';
import { CallforwordComponent } from './callforword/callforword.component';
import { environment } from '../../../environments/environment';

interface NotificationMessage {
    useravatar: string,
    status: string,
    from: string,
    subject: string,
    time: string,
    idlead: number,
    leaddata: string
}

export class Message {
    constructor(
        public sender: string,
        public content: string,
        public isBroadcast = false,
    ) { }
}

@Component({
    selector: 'ap-navigation',
    templateUrl: './navigation.component.html'
})
export class NavigationComponent implements AfterViewInit {
    public userimg = parseInt(sessionStorage.getItem('userid'))
    public isdefault: boolean = false;
    public dialerstatus: any;
    public callstatus: any;
    public number: number;
    public isblockdial: boolean = true;
    public minutes = parseInt(sessionStorage.getItem("minutes")) || 0;
    public buy_minutes = parseInt(sessionStorage.getItem("buy_minutes")) || 0;
    public total_minutes = this.minutes + this.buy_minutes;
    public callerid = sessionStorage.getItem("callerid") || "None";
    public current_number = sessionStorage.getItem("current_number") || "NA";
    public number_type = sessionStorage.getItem("number_type") || "NA";
    public agcall = false;
    public agentdialer: boolean = true;
    public pausedialer: boolean = false;
    public resumedialer: boolean = false;
    public leadid = sessionStorage.getItem("leadID") || -1;
    public currscript = sessionStorage.getItem("currscript") || -1;
    public extaccount = sessionStorage.getItem("extaccount") || "None";
    public __autohangup: boolean = false;
    public menu: boolean;
    public fullname: string = sessionStorage.getItem("fullname");
    public email: string = sessionStorage.getItem("email");
    public usertype = parseInt(sessionStorage.getItem("type")) || 0;
    public pkgnotify = JSON.parse(sessionStorage.getItem("companypkg")) || { users: 0, did: 0, minutes: 0, callerid: 0, sms: 0, voicemail: 0 };
    public iscallerid: boolean = false;
    public mymessages: NotificationMessage[] = [];
    public totalmsg = this.mymessages.length;
    public cbdata = [];
    private __notification = new BehaviorSubject<NotificationMessage[]>([]);
    public notification = this.__notification.asObservable();
    public dial_type: number = 0;
    public sipstatus: string = "";
    public callcounter: number;
    public callicon: any;
    public gotnotification: boolean = false;
    public isaccount: boolean = false;
    public totalcaler = [];
    @Output() alertcallback = new EventEmitter();
    public serverMessages = new Array<Message>();
    public clientMessage = '';
    public isBroadcast = false;
    public sender = '';
    public profile_image: string = sessionStorage.getItem("profile_image");
    public viewer: any;
    public keytype: number;
    public allglobalfilter = [];
    public smslistview = [];
    public totalsmsmsg: number = 0;
    public singlesmsview = [];
    public singlesmslist: any;
    public status = [{ icon: "mdi-phone-outgoing", value: "", title: "Caller Id" }];
    // public status1 = [{ icon: "mdi-timer-sand", value: this.total_minutes, title: "Remaining Minutes" }];
    public status1 = [{ icon: "mdi-timer-sand", value: this.total_minutes, title: "Remaining Minutes", role: 1 }, { icon: "mdi-message", value: sessionStorage.getItem("sms"), title: "Remaining SMS", role: parseInt(sessionStorage.getItem("sroles")) }, { icon: "mdi-voicemail", value: sessionStorage.getItem("voicemail"), title: "Remaining Voicemail", role: parseInt(sessionStorage.getItem("vroles")) }];
    public remainsms = { icon: "mdi-message", value: sessionStorage.getItem("sms"), title: "Remaining SMS" }
    public remainvoice = { icon: "mdi-voicemail", value: sessionStorage.getItem("voicemail"), title: "Remaining Voicemail" }
    public smsnotify: string = sessionStorage.getItem("issms");
    public isdialpad: boolean = false;

    public usercredit: number = (parseInt(sessionStorage.getItem("totalagents")) - 1) || 0;
    public didcredit: number = parseInt(sessionStorage.getItem("did_credit"));
    public isvmuser: number = parseInt(sessionStorage.getItem("agent"));
    public getCamp: any = sessionStorage.getItem("currcampaign");
    public ismgm: string = sessionStorage.getItem("ismgm");
    public ispersonal: boolean = false;
    public tWcall: boolean = false;
    public starttWcall: boolean = false;
    public hold: boolean = false;
    public mute: boolean = false;
    public mmsec = 0;
    public sssec = 0;
    public sms_img = false
    public isRunning = false;
    public timerId: any = 0;
    public showIcon;
    public iconFix: string;
    public srole = parseInt(sessionStorage.getItem("sroles"));

    public smspermission = sessionStorage.getItem("smsperm");
    public voicemailpermission = sessionStorage.getItem("voicemailperm");
    public smsAvailable: string;
    callTime = 0;
    callduration: any = "00:00:00";
    interval: any;
    IsVC: boolean = true;
    colInt: any;

    @ViewChild('searchbar') searchbar: ElementRef;

    public searchText = '';
    public toggleSearch: boolean = false;

    constructor(protected http: HttpClient, public theme: Theme, protected router: Router, protected auth: AuthenticationService, protected sipdata: SipJsService, protected iosocket: ServerSocket, public dialog: MatDialog, protected bottomSheet: MatBottomSheet) {
        if (sessionStorage.getItem("type") == '1' || sessionStorage.getItem("type") == '2' || sessionStorage.getItem("type") == '3' || sessionStorage.getItem("type") == '4')
            this.isaccount = true;
        this.totalcaler = JSON.parse(sessionStorage.getItem("allcallerid"));
        console.log(this.totalcaler);
        this.keytype = parseInt(sessionStorage.getItem("type"));
        this.callcounter = 0;
        this.smslistview = JSON.parse(sessionStorage.getItem("allsms"));

    }

    ngOnInit() {
        this.theme.showmenu.subscribe(res => {
            this.menu = res;
            console.log(this.menu);

        });
        /**profile check code  */

        let imgbasedir = location.origin;
        var imgexist = this.imageExists(imgbasedir + '/assets/profiles/' + this.profile_image);
        if (imgexist == 404) {
            this.profile_image = 'user.jpg';
        }
        /** profile check code here  */
        var idPackage = sessionStorage.getItem('id_package');
        console.log("idPackage", idPackage);

        // get Entity Type
        this.auth.getEntityType(idPackage).subscribe(res => {
            console.log(res);

            console.log("get brand_Type", res[0].brand_type);
            this.showIcon = res[0].brand_type;
            if (this.showIcon == 1) {
                this.iconFix = 'silver';

            } else if (this.showIcon == 2) {
                this.iconFix = 'gold';
            } else {
                this.iconFix = '';
            }
        });


        this.smsAvailable = sessionStorage.getItem("sms");


        this.theme.callerid.subscribe(res => {
            console.log("res::")
            console.log(res)
            if (res != null || res != undefined) {
                this.totalcaler = JSON.parse(sessionStorage.getItem("allcallerid"));
                this.status = [{ icon: "mdi-phone-outgoing", value: '+' + res.number, title: "Caller Id" }]; this.status1 = [{ icon: "mdi-timer-sand", value: this.total_minutes, title: "Remaining Minutes", role: 1 }, { icon: "mdi-message", value: sessionStorage.getItem("sms"), title: "Remaining SMS", role: parseInt(sessionStorage.getItem("sroles")) }, { icon: "mdi-voicemail", value: sessionStorage.getItem("voicemail"), title: "Remaining Voicemail", role: parseInt(sessionStorage.getItem("vroles")) }];
                sessionStorage.setItem('callerid', res.number);
                this.callerid = res.number;
                if (this.totalcaler != null && this.totalcaler != undefined) {
                    if (this.totalcaler.length > 0)
                        this.iscallerid = true;
                }
            }
        });

        this.theme.sipjsdata.subscribe(ress => {
            console.log("Call Response has been Accepted");
            console.log(ress);
            if (ress != null && ress != undefined) {
                this.tWcall = ress.includes("Connected");
                if (this.tWcall) {
                    this.startTimer();
                    this.starttWcall = false;
                }

                this.callicon = sessionStorage.getItem("number_type");
                this.callcounter = parseInt(sessionStorage.getItem("totalcallattempts"));
                this.sipstatus = ress;
                if (ress.includes("Disconnected"))
                    this.starttWcall = false;
                if (this.ispersonal) {
                    let prcheck = ress.split(" ");
                    if (prcheck[2] == 'Disconnected' || prcheck[2] == 'Rejected' || prcheck[2] == 'Unavailable' || prcheck[2] == 'No' || prcheck[2] == 'Unauthorized' || prcheck[2] == 'Wrong' || prcheck[2] == 'Busy' || prcheck[2] == 'Unregistered') {
                        this.ispersonal = false;
                        this.starttWcall = false;
                        this.mute = false;
                        this.hold = false;
                        this.stopTimer();
                    }
                }
            }
        });

        this.theme.pkgnotification.subscribe(res => {
            if (res != null || res != undefined) {
                this.pkgnotify = res;
            }
        });

        this.theme.globalfilter.subscribe(res => {
            console.log(res);
            if (res != null || res != undefined) {
                this.allglobalfilter = res;
                console.log(this.allglobalfilter);
            }
        });

        this.theme.currcallback.subscribe(res4 => {
            console.log(res4, "res4 line 226");
            if (res4) {
                this.mymessages = res4;
                this.totalmsg = res4.length;
            }
        });

        this.theme.newlead.subscribe(nres => {
            console.log("new leads : " + nres);
            if (nres) {
                if (this.dialerstatus != 1) {
                    this.minutes = parseInt(sessionStorage.getItem("minutes"));
                    this.buy_minutes = parseInt(sessionStorage.getItem("buy_minutes"));
                    this.total_minutes = this.minutes + this.buy_minutes;
                    this.current_number = sessionStorage.getItem("current_number");
                    this.callerid = sessionStorage.getItem("callerid");
                    this.status1 = [{ icon: "mdi-timer-sand", value: this.total_minutes, title: "Remaining Minutes", role: 1 }, { icon: "mdi-message", value: sessionStorage.getItem("sms"), title: "Remaining SMS", role: parseInt(sessionStorage.getItem("sroles")) }, { icon: "mdi-voicemail", value: sessionStorage.getItem("voicemail"), title: "Remaining Voicemail", role: parseInt(sessionStorage.getItem("vroles")) }];
                }
            }
        });

        this.theme.updatebalance.subscribe(tres => {
            console.log(tres);
            console.log("Update BALANCE");
            if (tres) {
                this.minutes = parseInt(sessionStorage.getItem("minutes"));
                this.buy_minutes = parseInt(sessionStorage.getItem("buy_minutes"));
                this.total_minutes = this.minutes + this.buy_minutes;
                this.status1 = [{ icon: "mdi-timer-sand", value: this.total_minutes, title: "Remaining Minutes", role: 1 }, { icon: "mdi-message", value: sessionStorage.getItem("sms"), title: "Remaining SMS", role: parseInt(sessionStorage.getItem("sroles")) }, { icon: "mdi-voicemail", value: sessionStorage.getItem("voicemail"), title: "Remaining Voicemail", role: parseInt(sessionStorage.getItem("vroles")) }];
                this.theme.UpdateBalance(false);
            }
        });

        this.theme.profilepic.subscribe(res => {
            if (res != null || res != undefined) {
                this.profile_image = sessionStorage.getItem("profile_image");
                let imgbasedir = location.origin;
                var imgexist = this.imageExists(imgbasedir + '/assets/profiles/' + this.profile_image);
                if (imgexist == 404) {
                    this.profile_image = 'user.jpg';
                }

            }
        });

        this.theme.allsmslistview.subscribe(res => {
            if (res != null && res != undefined) {
                this.singlesmsview = res;
                console.log(res);
                this.smslistview = [];
                let count = 0;

                for (let i = 0; i < res.length; i++) {
                    if (res[i].isview > 0)
                        count++;
                    if (i < 6) {
                        this.smslistview.push(res[i]);
                    }
                    this.smsnotify = 'yes';
                }

                this.totalsmsmsg = count;
                this.singlesmslist = res[0];
                sessionStorage.setItem("allsms", JSON.stringify(this.smslistview));
                this.smsnotify = 'yes';

            }

        });


        this.theme.showdialpad.subscribe(res => {
            if (res) {
                this.isdialpad = true;
            }
            else {
                this.isdialpad = false;
            }
        });

        /* Block Autodial for few state */
        this.theme.blockautodial.subscribe(res => {
            console.log("BBB: ", res);
            if (res != null && res != undefined)
                this.isblockdial = false;
            else
                this.isblockdial = true;
        });

        this.theme.totalagents.subscribe(res => {
            this.usercredit = parseInt(sessionStorage.getItem("totalagents")) - 1;
        });

    }

    /* OPen Dial Pad */
    OpenDialpad() {
        const dialogRef = this.dialog.open(DialpadComponent, {
            width: '300px',
            data: {}
        });

        dialogRef.afterClosed().subscribe(result => { });
    }

    /* Dial Personal Number */
    DialPersonalNumber() {
        const dialogRef = this.dialog.open(DialpersonalComponent, {
            width: '400px',
            data: { dialstatus: this.isdialpad }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result != null && result != undefined) {
                this.ispersonal = true;
            }
        });
    }

    alertSmsNotification(smsdata: any, i: number) {
        sessionStorage.setItem("singlesms", JSON.stringify(smsdata));
        sessionStorage.setItem("index", JSON.stringify(i));
        this.router.navigate(['/smschat']);
        //this.theme.SingleSMSView(smsdata);
    }

    BuyMinutes() {
        this.theme.showMenu(true);
        sessionStorage.setItem("ispkg", (1).toString());
        this.router.navigate(['/account']);
    }

    alertNotification(number: number) {
        console.log(this.getCamp, number, 'suddd');
        this.getCamp = sessionStorage.getItem("currcampaign");

        if (number == 0) {
            this.router.navigate(['/dialer/alertcallback'],
                { queryParams: { getCamp: number } });
        } else {
            this.router.navigate(['/dialer/alertcallback'],
                { queryParams: { getCamp: this.getCamp } });
        }
    }

    DialerMenu(menutype: number) {
        this.theme.ChangeColor('green');
        this.theme.showMenu(true);
        if (menutype == 1)
            this.router.navigate(['/dialer/campaign']);
        if (menutype == 2)
            this.router.navigate(['/setting']);
        if (menutype == 3)
            this.router.navigate(['/calendar']);
        if (menutype == 4)
            this.UserLogout();
        if (menutype == 0) {
            let dashreport = parseInt(sessionStorage.getItem("isreport"));
            if (dashreport == 1)
                this.router.navigate(['/login/ndsisense']);
            else
                this.router.navigate(['/dashboards/dashboard6']);
        }
        //this.router.navigate ( ['/dashboards/dashboard1'] );
        this.theme.UnregisterSIP(true);
    }

    AccountUser() {
        this.router.navigate(['/account']);
    }

    Hangup() {
        this.ispersonal = false;
        this.sipdata.HangupCall();
    }

    UserLogout() {
        this.auth.logout();
    }

    LoadLead(data: any) {
        this.theme.CallBackLead(data);
    }

    CallbackLoadLead(data: any) {
        console.log(data);
        sessionStorage.setItem('currcampaign', data.id_dialer);
        sessionStorage.setItem('currcampflag', data.dialer_type);
        sessionStorage.setItem("loadlead", data.id);
        this.router.navigate(['/dialer']);
    }

    filterLeads(filter: any) {
        console.log(filter);
        this.theme.LoadFilterLeads(JSON.stringify(filter));
    }

    NewFilterLeads() {
        sessionStorage.setItem("isglobal", (1).toString());
        this.router.navigate(['/setting']);
    }

    onSearch(event: any, searchtext: string) {
        console.log("Search called");
        if (event.keyCode == 13) {
            console.log("Search key :: " + event.keyCode + " ,  Search Data: " + searchtext);
            this.theme.SearchLead(searchtext);
        }
    }

    RotateCallerId(type: number, sdata: any) {
        let preference = JSON.parse(sessionStorage.getItem('preferences'));
        switch (type) {
            case 1:
                {
                    this.theme.ChangeRotateCaller({ sdata: { didpicktype: "automatic" }, pref: preference.id });
                    break;
                }
            case 2:
                {
                    this.theme.ChangeRotateCaller({ sdata: { didpicktype: "localid" }, pref: preference.id });
                    break;
                }
            case 3:
                {
                    this.theme.ChangeRotateCaller({ sdata: { didpicktype: "manual", manual_did: sdata }, pref: preference.id });
                    break;
                }
        }
    }

    autodialing(event: number) {
        
        console.log('autodialing ' + event);
        if (event > 0) {
            if (event == 1) // Start Autodial
            {
                this.agentdialer = false;
                this.pausedialer = true;
                sessionStorage.setItem('isautodial', event.toString());
            }
            if (event == 2) // Pause Autodil
            {
                this.resumedialer = true;
                this.pausedialer = false;
                sessionStorage.setItem('isautodial', (0).toString());
            }
            if (event == 3) // Resume Autodial
            {
                this.resumedialer = false;
                this.pausedialer = true;
                sessionStorage.setItem("phonetype", "1");
                sessionStorage.setItem('isautodial', (1).toString());
            }
            this.theme.ChangeAutodial(event);
            this.theme.ChangeEvent(event);
        }
        else {
            this.agentdialer = true;
            this.resumedialer = false;
            this.pausedialer = false;
            sessionStorage.setItem('isautodial', (0).toString());
            this.sipdata.HangupCall();
            console.log("test::")
            this.theme.ChangeAutodial(0);
            this.theme.StopAutodial(1);
        }
    }

    profile() {
        this.router.navigate(['/profile']);
    }

    ClickLogo() {
        let dashreport = parseInt(sessionStorage.getItem("isreport"));
        if (dashreport == 1)
            this.router.navigate(['/login/ndsisense']);
        else
            this.router.navigate(['/dashboards/dashboard6']);
    }

    public toggleIsBroadcast(): void {
        this.isBroadcast = !this.isBroadcast;
    }

    public send(): void { }

    public isMine(message: Message): boolean {
        return message && message.sender === this.sender;
    }

    public getSenderInitials(sender: string): string {
        return sender && sender.substring(0, 2).toLocaleUpperCase();
    }

    public getSenderColor(sender: string): string {
        const alpha = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZ';
        const initials = this.getSenderInitials(sender);
        const value = Math.ceil((alpha.indexOf(initials[0]) + alpha.indexOf(initials[1])) * 255 * 255 * 255 / 70);
        return '#' + value.toString(16).padEnd(6, '0');
    }

    private scroll(): void {
        setTimeout(() => {
            this.scrollToBottom();
        }, 100);
    }

    private getDiff(): number {
        if (!this.viewer) {
            return -1;
        }

        const nativeElement = this.viewer.nativeElement;
        return nativeElement.scrollHeight - (nativeElement.scrollTop + nativeElement.clientHeight);
    }

    private scrollToBottom(t = 1, b = 0): void {
        console.log("Scroll Running with tt ::" + t + " AND bb :: " + b);
        if (b < 1) {
            b = this.getDiff();
        }
        if (b > 0 && t <= 120) {
            setTimeout(() => {
                const diff = this.easeInOutSin(t / 120) * this.getDiff();
                this.viewer.nativeElement.scrollTop += diff;
                this.scrollToBottom(++t, b);
            }, 1 / 60);
        }
    }

    private easeInOutSin(t): number {
        return (1 + Math.sin(Math.PI * t - Math.PI / 2)) / 2;
    }

    ngAfterViewInit() {

        var set = function () {
            var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
            var topOffset = 0;
            if (width < 1170) {
                $("#main-wrapper").addClass("mini-sidebar");
            } else {
                $("#main-wrapper").removeClass("mini-sidebar");
            }
        };
        $(window).ready(set);
        $(window).on("resize", set);


        $(".search-box a, .search-box .app-search .srh-btn").on('click', function () {
            $(".app-search").toggle(200);
        });

        $("body").trigger("resize");
    }

    ChangeProfile() {
        this.fullname = sessionStorage.getItem("fullname");
        this.email = sessionStorage.getItem("email");
    }

    SwitchtoAgency() {
        sessionStorage.removeItem("ismgm");
        sessionStorage.setItem("ismgm", "no");
        this.auth.SwitchAccount();
    }

    SwitchtoSupervisor() {
        sessionStorage.setItem("ismgm", "yes");
        this.auth.SwitchSupervisor();
    }

    VMUsersLogin() {
        this.auth.Movetovirtualmentor();
    }

    SendDTMF(key: string) {
        this.theme.SendDTMFSip(key);
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(CallforwordComponent, {
            width: '600px',
            height: 'auto',
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
            console.log(result);
            if (result != undefined) {
                if (result.type == 1)
                    this.sipdata.CallTransfer(result.number);
                if (result.type == 2) {
                    this.starttWcall = true;
                    this.tWcall = false;
                    this.theme.SendDTMFSip("*4" + result.number);
                }
            }
        });
    }

    MuteCall(key: number) {
        if (key == 1) {
            this.sipdata.MuteCall();
            this.mute = true;
        }
        if (key == 0) {
            this.sipdata.UnMuteCall();
            this.mute = false;
        }
    }

    HoldCall(key: number) {
        if (key == 1) {
            this.sipdata.HoldCall();
            this.hold = true;
        }
        if (key == 0) {
            this.sipdata.UnHoldCall();
            this.hold = false;
        }
    }

    clickHandler() {
        console.log("clickHandler");

        if (!this.isRunning) {
            // Stop => Running

            this.timerId = setInterval(() => {
                this.sssec++;
                if (this.sssec >= 60) {
                    this.mmsec++;
                    this.sssec = 0
                }
            }, 1000);
        } else {
            clearInterval(this.timerId);
        }

        this.isRunning = !this.isRunning;
    }

    format(num: number) {
        return (num + '').length === 1 ? '0' + num : num + '';
    }

    // sms notification string split
    getShortName(fullName) {
        let fullname = fullName.split(' ').map(n => n[0]).join(' ').slice(0, 3);
        if (isNaN(parseInt(fullname))) {
            return fullname

        } else {

            return fullname = "UN"
        }

    }

    VmInsuranceSearch(): void {
        if (sessionStorage.getItem("vm_session")) {
            let vm_session: any = sessionStorage.getItem("vm_session")
            window.open(environment.VM_ACCESS + "?vm_session=" + vm_session, "_blank")
        } else {
            alert("You must have VM account\nTo search the insurance!")
        }
    }

    openSearch() {
        this.toggleSearch = true;
        this.searchbar.nativeElement.focus();
    }

    searchClose() {
        this.searchText = '';
        this.toggleSearch = false;
    }
    
    startTimer() {
        //this.callduration = '00:00:00';
        this.stopTimer();
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.interval = setInterval(() => {
            this.updTimer();
        }, 1000);

        if (this.colInt) {
            clearInterval(this.colInt);
        }
        this.colInt = setInterval(() => {
            let a = this.callduration.split(':');
            let seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
            if (seconds >= 180) {
                this.IsVC = false
            }
        }, 1000);
    }

    updTimer() {
        let day = '00';
        this.callTime += 1000;
        if (this.callTime >= 86400000) {
            let d = ~~(this.callTime / 86400000);
            day = d.toString();
        }
        if (day != '00') {
            this.callduration = day + ':' + new Date(this.callTime).toUTCString().split(/ /)[4];
        } else {
            this.callduration = new Date(this.callTime).toUTCString().split(/ /)[4];
        }
    }

    stopTimer() {
        this.callTime = 0;
        this.callduration = '00:00:00';
        if (this.interval) {
            clearInterval(this.interval);
        }
        if (this.colInt) {
            this.IsVC = true
            clearInterval(this.colInt);
        }
    }

    imageExists(image_url) {
        var http = new XMLHttpRequest();
        http.open('HEAD', image_url, false);
        http.send();
        return http.status;
    }



}
